/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 09/23/2019
 *
 * @version 0.2
 * Revisions:
 * 09/23/2019 - BW - Initial Creation
 * 03/15/2021 - BW - Modified: _onForgotUsernameClick - added:"$event.preventDefault()"
 * 03/15/2021 - BW - Modified: _onForgotPasswordClick - added:"$event.preventDefault()"
 * 12/13/2024 - BW - Added: onSsoLoginClick
 *
 * Description/Purpose:
 * Login JS
 ************************************************************** */
import '../../../scss/page/login/login.scss';


import PubSub from 'pubsub-js';
import PUBSUB_EVENT from 'constant/pubsub-event';
import ValidateForm from 'util/validate-form';
import ButtonUtil from "util/button-util";
import StackTraceError from "component/stack-trace-error/stack-trace-error";
import { LoginCookie } from 'page/login/login-cookie';
import ForgotCredential from 'page/login/forgot-credential';
import BrowserData from "page/login/browser-data";


const Login = {
  _$form: $('#login_form'),
  _$isDocumentForward: $('#is_document_forward'),
  _$username: $('[name=j_username]'),
  _$password: $('[name=j_password]'),
  _$rememberMe: $('#remember_me'),
  _$forgotUsername: $('#forgot_username'),
  _$forgotPassword: $('#forgot_password'),
  _$loginButton: $('#login_button'),
  _loginCookie: new LoginCookie(),
  _$loginSsoServletUrl: $('#login_sso_servlet_url'),
  _$ssoLoginButton: $('#sso_login_button'),
  _$ssoAdminLoginButton: $('#sso_admin_login_button'),
  /**
     * Init this process - should be the only cll we make below to setup this pages's JS
     */
  init() {
    try {
      this._checkURL();
      this._registerEvent();
      this._loginCookie.render();
      BrowserData.setBrowserData();
    } catch (e) {
      StackTraceError.processError(e, 'Login - Init');
    }
  },


  /**
     * Register events or DOM event
     * @private
     */
  _registerEvent() {
    try {
      this._registerValidateForm();
      this._$forgotUsername.click(($event) => this._onForgotUsernameClick($event));
      this._$forgotPassword.click(($event) => this._onForgotPasswordClick($event));
      this._$ssoLoginButton.click(($event) => this._onSsoLoginClick($event, 'fe'));
      this._$ssoAdminLoginButton.click(($event) => this._onSsoLoginClick($event, 'be'));
      PubSub.subscribe(PUBSUB_EVENT.SET_BROWSER_DATA_COMPLETE, this._checkAutoLogin.bind(this));
    } catch (e) {
      StackTraceError.processError(e, 'Login - Register Event');
    }
  },


  /**
     * Register the ValidateForm Event and setup the object
     * @private
     */
  _registerValidateForm() {
    try {
      this.validateForm = new ValidateForm(this._$form)
        .addRules({
          j_username: {
            required: true,
            email: false,
          },
          j_password: "required",
        })
        .addMessages({
          j_username: {
            required: "Username is required.",
          },
          j_password: {
            required: "Password is required.",
          },
        })
        .addSubmitHandler(this._onLoginFormSubmit.bind(this))
        .init();
    } catch (e) {
      StackTraceError.processError(e, 'Login - Register Validate Form');
    }
  },


  /**
     * Will check to see if we should auto login the user
     * @private
     */
  _checkAutoLogin() {
    try {
      if (this._$isDocumentForward.val() === 'true' && this._$username.val()
                && this._$password.val() && this._$rememberMe.is(':checked')) {
        this._$form.submit();
      }
    } catch (e) {
      StackTraceError.processError(e, 'Login - Check Auto Login');
    }
  },


  /**
     * Login Form Submit Event
     * Gets called as a callback from the ValidateForm only after all the validation has passed will this fire.
     * @param $event
     * @private
     */
  _onLoginFormSubmit($event) {
    try {
      // $event.preventDefault();
      ButtonUtil.enableProcessingButton(this._$loginButton);
      this._loginCookie.addCookie();
      this._$form.unbind('submit').submit();
    } catch (e) {
      StackTraceError.processError(e, 'Login - Form Submit');
    }
  },


  /**
     * Forgot Username click Event
     * @param $event
     * @private
     */
  _onForgotUsernameClick($event) {
    try {
      $event.preventDefault();
      new ForgotCredential($event, ForgotCredential.typeUsername).open();
    } catch (e) {
      StackTraceError.processError(e, 'Login-  Forgot Username Click');
    }
  },


  /**
     * Forgot Password click Event
     * @param $event
     * @private
     */
  _onForgotPasswordClick($event) {
    try {
      $event.preventDefault();
      new ForgotCredential($event, ForgotCredential.typePassword).open();
    } catch (e) {
      StackTraceError.processError(e, 'Login - Forgot Password Click');
    }
  },


  /**
     * Trying to help prevent users from getting 'stuck' in the 'j_security_check' form
     // and getting a 400 error.
     // TODO: not entirely sure why I need this.  It was in the old version - login.jsp
     */
  _checkURL() {
    const pathName = `/${document.location.pathname.replace(/\//g, '')}`;
    const context = $("body").data("context");
    if ((pathName !== context) && (pathName !== `${context}j_security_check`)
        && (pathName.indexOf("caDocId") !== -1) && (pathName.indexOf("caLegDocId") !== -1)
        && (pathName.indexOf("caDocProdId") !== -1) && (pathName.indexOf("caMsgBrdId") !== -1)
        && (pathName.indexOf("caFileExpId") !== -1) && (pathName.indexOf("caPaymentId") !== -1)
        && (pathName.indexOf("caDepoId") !== -1)) {
      window.location.replace = context;
    }
  },


  /**
   * SSO Login Click Event
   * @param $event
   * @param to
   */
  _onSsoLoginClick($event, to) {
    try {
      $event.preventDefault();
      window.location.href = `${this._$loginSsoServletUrl.val()}?to=${to}`;
    } catch (e) {
      StackTraceError.processError(e, 'SSO Login Click');
    }
  },


};

$(() => {
  try {
    Login.init();
  } catch (e) {
    StackTraceError.processError(e, 'Login Init Call');
  }
});
